module.exports = __webpack_public_path__ + "img/0803-magnifier.d556530c.svg";